import { TextFilterProps } from '@progress/kendo-react-data-tools'
import { useAppSelector } from 'store'

import { MultiSelectFilter } from '../MultiSelectFilter'

export const TradingAccountSymbolFilter: React.FC<TextFilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const symbols = useAppSelector((state) => state.tradingAccounts.instruments)
  const data = symbols.map((x) => ({ id: x.id, label: x.symbol, value: x.id }))

  return (
    <MultiSelectFilter
      placeholder='Symbols'
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
    />
  )
}
